import React from "react";
import "./privacyPolicy.scss";

const PrivacyPolicy = () => {
  return (
    <>
      <div id="privacy-policy-wrapper">
        <section style={{ padding: "2rem 0" }}>
          <div className="container">
            <div className="the_content_single">
              <h2>Privacy Policy</h2>
              <h4>Effective Date: May 25, 2023</h4>
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sed
                explicabo dolore in, repellendus maiores quo tempore architecto
                sint? Repellendus totam omnis ex similique iste cupiditate iure?
                Hic aliquam vitae exercitationem!
              </p>
              <h2>Information We Collect:</h2>
              <h3>1.1 Personal Information:</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam
                cum vitae iste! Qui suscipit quidem corrupti laborum quia,
                debitis odio voluptatibus quasi? Harum possimus quam voluptates
                iste, quos laudantium ea.
              </p>
              <h3>1.2 Usage Information:</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste
                odit rerum repellendus vitae error. Rem eos dicta, eius tempore
                consequatur facere nemo porro dolores, similique ipsa illo
                itaque? Sapiente, culpa!
              </p>
              <h2>Use of Information:</h2>
              <h3>2.1 Personal Information:</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Temporibus, officiis illum eligendi cum ex impedit quibusdam
                mollitia dolorem molestiae et suscipit blanditiis doloremque aut
                id, ipsa quam pariatur quo consequatur.
              </p>
              <h3>1.2 Usage Information:</h3>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minima
                laboriosam cumque, et mollitia doloremque cum quis, obcaecati ad
                deleniti labore adipisci reiciendis veniam nihil, saepe id eius
                a molestiae illo.
              </p>

              <h2>Disclosure of Information:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure
                laudantium veritatis quas, animi rem nemo quisquam
                exercitationem eum nam harum? Iste deleniti adipisci cumque
                omnis, ut neque eius officia corporis!
              </p>
              <h2>Legal Requirements:</h2>
              <p>
                We may disclose your personal information if required to do so
                by law or in response to a valid legal request, such as a court
                order or government inquiry.
              </p>
              <h2>Service Providers:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Molestiae recusandae provident necessitatibus ipsa tempora
                corporis amet quis! Inventore ullam, blanditiis molestiae vitae
                dolorum et aperiam, sint, voluptate laudantium mollitia ad?
              </p>
              <h2>Security:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit
                ad, facere ratione quasi neque deserunt quis omnis doloribus
                laudantium! Commodi perspiciatis aliquid tempora atque ea
                dolores explicabo magni eum laboriosam.
              </p>
              <h2>Third-Party Links:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor
                cumque repellendus officiis porro necessitatibus a! Rem, esse
                tempora vero nemo excepturi fuga laudantium obcaecati
                architecto. Sit et sed vitae omnis!
              </p>
              <h2>Your Choices:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Praesentium, laboriosam quia et id exercitationem tempore animi
                vel commodi dolore nemo, recusandae asperiores velit fuga ex
                nobis rerum possimus at eligendi.
              </p>
              <h2>Children's Privacy:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum,
                voluptas aspernatur quidem quod modi non tempora debitis ex
                consequuntur laborum accusantium recusandae ipsam laudantium
                necessitatibus neque dolor magni maxime cumque!
              </p>
              <h2>Changes to the Privacy Policy:</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Quaerat voluptatem, voluptatum, quos quasi sequi quas, tempore
                ipsum aut distinctio ipsa deserunt adipisci officia? Vero qui
                quisquam magnam beatae ipsa non.
              </p>
              <h2>Contact Us:</h2>
              <p>
                If you have any questions or concerns regarding this Privacy
                Policy or our privacy.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
